export enum UrlTypeEnum {
    'IMAGE_URL' = 17
  }